import React from "react";

const Dashboard = () => {

  const user = JSON.parse(localStorage.getItem("user"));

  return (

    <div className="dashboard">

      <h1>Welcome {user?.name}</h1>

      <p>You have successfully logged in.</p>

      <h3>This is your dashboard page.</h3>

    </div>

  );
};

export default Dashboard;